import { render, staticRenderFns } from "./EsgTableWithMeta.vue?vue&type=template&id=53315e05"
import script from "./EsgTableWithMeta.vue?vue&type=script&lang=js"
export * from "./EsgTableWithMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports